<h2 mat-dialog-title>
  {{ 'AUTOMATIONS.EDITOR.CURRENTLY_WAITING.DIALOG_TITLE' | translate }}
</h2>
<mat-dialog-content>
  <div id="currentlyWaitingActivityTable">
    <va-filtered-mat-table [tableDataService]="dataService"></va-filtered-mat-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
